import { LocalVideo, RemoteVideo, useAttendeeStatus } from 'amazon-chime-sdk-component-library-react';
import classNames from 'classnames';
import React from 'react';
import { useExternalUserId, useSession, useTileId } from '../../session-provider';
import { useVideoConfig } from '../../video-config-provider';
import s from './tile.scss';
import { Content } from './content';
export var Tile = function (_a) {
    var _b;
    var className = _a.className, attendeeId = _a.attendeeId, focused = _a.focused;
    var _c = useVideoConfig(), renderAvatar = _c.renderAvatar, video = _c.video, dashboard = _c.dashboard;
    var currentAttendeeId = useSession().currentAttendeeId;
    var attendeeVideoEnabled = useAttendeeStatus(attendeeId).videoEnabled;
    var tileId = useTileId(attendeeId);
    var externalUserId = useExternalUserId(attendeeId);
    var localTile = attendeeId === currentAttendeeId;
    var videoEnabled = localTile ? video : attendeeVideoEnabled;
    return videoEnabled ? (React.createElement(Content, { className: className, attendeeId: attendeeId, focused: focused }, localTile ? React.createElement(LocalVideo, null) : React.createElement(RemoteVideo, { tileId: tileId }))) : (React.createElement(Content, { className: classNames(className, s.tile, (_b = {}, _b[s.dashboardTile] = dashboard, _b)), attendeeId: attendeeId, focused: focused }, Boolean(renderAvatar) && renderAvatar(externalUserId)));
};
//# sourceMappingURL=tile.js.map